import React, { useEffect, useState } from 'react';
import { TypographyStyledHeader, BoxStyled } from './style';
import { NavigationButtons } from '../../../shared/components/navigationButtons';
import { Box } from '@mui/material';
import { TextWithInfoIcon } from '../../../shared/components/textWithInfoIcon';
import { ArcContainer } from '../../../shared/components/arcContainer';
import { DoubleTextBlueCardStyled } from '../../../shared/components/doubleTextBlueCardStyled';
import { DoubleNumberCard } from '../../../shared/components/numberInput/numberCards/doubleNumberCard';
import graphIcon from '../../../assets/icons/graphIcon.svg';
import desktopIcon from '../../../assets/icons/desktopIcon.svg';
import InfoIcon from '../../../assets/icons/infoIcon.svg';
import { InfoModal } from '../../../shared/components/modal/InfoModal';

import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../../store/hooks';
import { metaDataSelector } from '../../../store/globalSelectors';
import { setSimpleCaloricSelection } from '../../../store/slices/metaDataSlice';
import { calEnergyWrtWeight } from '../../../shared/utils/utilFunctions';

export const SimpleCaloricEquation = () => {
  const { estimatingRequirements, patientInformation } =
    useAppSelector(metaDataSelector);
  const { simpleCaloricEquation } = estimatingRequirements;
  const { metric } = patientInformation;
  const { weight, estimatedDryWeight } = metric;
  const dispatch = useDispatch();
  const [min, setMinEnergy] = useState(
    simpleCaloricEquation.calorieRange.energy.min
  );
  const [max, setMaxEnergy] = useState(
    simpleCaloricEquation.calorieRange.energy.max
  );

  useEffect(() => {
    const consideredWeight =
      estimatedDryWeight > 0 ? estimatedDryWeight : weight;
    let calculatedMinEnergy = 0,
      calculatedMaxEnergy = 0;
    // const consideredWeight = 10;
    if (consideredWeight > 0) {
      calculatedMinEnergy = calEnergyWrtWeight(
        simpleCaloricEquation.calorieRange.energy.min,
        consideredWeight
      );
      calculatedMaxEnergy = calEnergyWrtWeight(
        simpleCaloricEquation.calorieRange.energy.max,
        consideredWeight
      );
    }
    dispatch(
      setSimpleCaloricSelection({
        ...simpleCaloricEquation,
        min: calculatedMinEnergy,
        max: calculatedMaxEnergy
      })
    );
    setMinEnergy(calculatedMinEnergy);
    setMaxEnergy(calculatedMaxEnergy);
  }, [
    simpleCaloricEquation.calorieRange.energy.min,
    simpleCaloricEquation.calorieRange.energy.max
  ]);

  const [openInfoModal, setOpenInfoModal] = useState(false);
  return (
    <>
      <BoxStyled>
        {/* Top Bar (title + info icon) */}
        <TextWithInfoIcon
          title={'SIMPLE CALORIC EQUATION'}
          icon={InfoIcon}
          fontSize={'1.5rem'}
          lineHeight={'1.375rem'}
          variant={'h1'}
          handleIconClick={() => setOpenInfoModal(true)}
        />
        <ArcContainer icon={desktopIcon}>
          <Box sx={{ textAlign: 'center', mb: 2, mt: 5 }}>
            <TypographyStyledHeader className="pt-16">{`CHOOSE A RANGE OF CALORIES BELOW`}</TypographyStyledHeader>
            <Box
              sx={{
                border: '0.0625rem solid #D9D9D6',
                borderRadius: '0.9375rem',
                marginTop: '1.25rem'
              }}
            >
              <DoubleNumberCard
                title={''}
                subHead3={'(kcal/kg/day)'}
                subHead1={'(min)'}
                subHead2={'(max)'}
                range1={{ min: 0, max: 1000 }}
                range2={{ min: 0, max: 1000 }}
                value1={simpleCaloricEquation.calorieRange.energy.min}
                value2={simpleCaloricEquation.calorieRange.energy.max}
                setValue1={(val: number) =>
                  dispatch(
                    setSimpleCaloricSelection({
                      ...simpleCaloricEquation,
                      calorieRange: {
                        ...simpleCaloricEquation.calorieRange,
                        energy: {
                          ...simpleCaloricEquation.calorieRange.energy,
                          min: Number(val)
                        }
                      }
                    })
                  )
                }
                setValue2={(val: number) =>
                  dispatch(
                    setSimpleCaloricSelection({
                      ...simpleCaloricEquation,
                      calorieRange: {
                        ...simpleCaloricEquation.calorieRange,
                        energy: {
                          ...simpleCaloricEquation.calorieRange.energy,
                          max: Number(val)
                        }
                      }
                    })
                  )
                }
              />
            </Box>
          </Box>

          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2, mt: 5 }}>
            <DoubleTextBlueCardStyled
              heading1="MIN"
              label1={`${min} kcal/day`}
              heading2="MAX"
              label2={`${max} kcal/day`}
              icon={graphIcon}
            />
          </Box>
        </ArcContainer>
      </BoxStyled>

      <NavigationButtons
        nextDisabled={false}
        nextRoute={
          patientInformation.type === 'PAEDIATRIC'
            ? '/estimating-requirements/paediatric-energy'
            : '/estimating-requirements/protein'
        }
      />
      <InfoModal
        open={openInfoModal}
        onClose={() => setOpenInfoModal(false)}
        title={'Reference'}
        content={
          'Irish Nutrition and Dietetic Institute (2022) Nutrition Support Reference Guide.'
        }
      />
    </>
  );
};
